import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import type { RegisteredActivityName } from '@stackflow/config';
import { useFlow } from '@stackflow/react';
import { ReactNode } from 'react';

export interface AuthFlow {
    activityName: RegisteredActivityName,
    activityParams: object,
}

interface Props {
    children: ReactNode;
    className?: string,
    flows?: AuthFlow[],
}

function AuthGuard({ children, className, flows }: Props) {
    const { user } = useUser();
    const { push } = useFlow();
    return (
        <Wrapper className={className}
            isLocked={!user}
            onClick={(e) => {
                if (!user) {
                    e.preventDefault();
                    e.stopPropagation();
                    push('SignInActivity', { flows });
                }
            }} >
            {children}
        </Wrapper>
    );
}

const Wrapper = styled.div<{
    isLocked: boolean;
}>`
    width: 100%;

    ${({ isLocked }) => isLocked && css`
        * {
            pointer-events: none;
        }
    `}
`;

export default AuthGuard;
